/*
 *
 * Copyright (c) 2025 Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Alexander Orlov ("CONFIDENTIAL INFORMATION").
 *
 * Use, reproduction, modification, or distribution of this code
 * is permitted only pursuant to a written license expressly granted
 * by Alexander Orlov.
 *
 * You shall not disclose such confidential information and shall use
 * it only in accordance with the terms of the written license agreement
 * you have entered into with Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft
 *
 */

// Browser polyfills for Node.js modules
import { Buffer } from 'buffer';

// Ensure Buffer is available globally for react-pdf and other libraries
if (typeof globalThis !== 'undefined') {
  globalThis.Buffer = Buffer;
}

if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  // @ts-ignore
  window.global = globalThis;
}

// Additional polyfills for react-pdf
if (typeof global === 'undefined') {
  // @ts-ignore
  globalThis.global = globalThis;
}

export { Buffer };